import React, { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';
import { useNavigate } from 'react-router-dom';
import ContactFormpage from "../components/ContactFormpage";
import SeoHelmet from "../components/SeoHelmet";
import ContactModal from "../components/ContactModal";

import slide1 from '../assets/img/contact_bg.jpg';
import Phone from '../assets/img/contact_phone.svg';
import Email from '../assets/img/contact-email.svg';
import Location from '../assets/img/contact_location.svg';


const Contact = () => {
  const formRef = useRef(); // To reference the form
  const [status, setStatus] = useState(''); // For success or error messages
  const navigate = useNavigate();

  const sendEmail = (e) => {
    e.preventDefault();

    // Use the emailjs library to send the email
    emailjs
    .sendForm(
      "service_hmrezop", // Your EmailJS service ID
      "template_6qlhzgj", // Your EmailJS template ID
      formRef.current, // The form reference
      "1eblwEiXOqFJO88JY" // Your EmailJS user ID
    )
      .then(
        (result) => {
          console.log('SUCCESS!', result.text);
          setStatus('Message sent successfully!'); // Show success message
          formRef.current.reset(); // Reset the form after submission
          // Redirect after success using React Router
          setTimeout(() => {
            navigate('/thank-you'); // This will redirect to the thank you page
          }, 2000); // Delay before redirecting
        },
        (error) => {
          console.error('FAILED...', error.text);
          setStatus('Failed to send message. Please try again.'); // Show error message
        }
      );
  };


  
  return (
    <>
     <SeoHelmet />
      <ContactModal />
    <section>
        <div className="swiper animeslide">
          <div className="swiper-wrapper">

            <div className="swiper-slide animeslide-slide slide1 design_banner" style={{ backgroundImage: `url(${slide1})` }}>
              <div className="container">
                <div className="row">
                   <div className="col-sm-12 banner_content">
                    <div className="content-slide">
                      <div data-animate="bottom" className="animeslide-heading">
                        <h2>Contact us</h2>
                        <p>we specialise in creating uniforms that serve both <br></br>purpose and poise.</p>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>


          </div>
          <div className="flex animeslide-bottom">
            <div className="animeslide-pagination swiper-pagination"></div>
          </div>
        </div>
      </section>
    <section className="get_touch">
        <div className="container">
            <div className="get_touch_title">
                <h2>In need of help?</h2>
                <p>Get in touch with us</p>
            </div>
            <div className="contact_details">
                <div className="row">
                    <div className="col-sm-4">
                        <div className="contact-detail">
                            <div className="contact_info">
                                <img src={Phone} alt="" className='logom' />
                                <p><a href='tel:+917358376222'>+91-7358376222</a>  <br></br>
                                    <a href='tel:+917358376333'>+91-7358376333</a></p>
                            </div>
                            <div className="contact_info">
                                <img src={Email} alt="" className='logom' />
                                <p><a href='mailto:contact@saraogi.in'>contact@saraogi.in</a></p>
                            </div>
                            <div className="contact_info location" >
                                <img src={Location} alt="" className='logom' />
                                <p><a href='https://share.google/3QQ1S4WJZbDmKAsVD'>First Floor, 1/72, <br></br>
                                  Poonamallee High Rd,<br></br> Nerkundram, Chennai, Tamil Nadu 600107, India</a></p>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-1"></div>
                    <div className="col-sm-7">
                        <ContactFormpage />


                    </div>

                </div>
            </div>
        </div>

    </section>

    
   
    </>
  );
};

export default Contact;
